module.exports = __webpack_public_path__ + "static/media/page1.5ba579f1.png";